import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Session } from '../services/session';

export function roleGuard(...roles: string[]): CanActivateFn {
  return () => {
    const router = inject(Router);
    const session = inject(Session);

    const decoded = session.getDecodedUser();

    if (decoded && roles.includes(decoded.role)) {
      return true;
    }

    return router.createUrlTree(['/dashboard']);
  };
}
